import { createFileRoute, useParams } from "@tanstack/react-router";
import { requirePermission } from "@/lib/feature-gate";
import { z } from "zod";
import { AccountDetailPage } from "@/components/crm/AccountDetailPage";

export const Route = createFileRoute("/admin/_layout/crm/accounts_/$id")({
  beforeLoad: async () => {
    await requirePermission("crm.account.view");
  },
  validateSearch: z.object({ tab: z.string().min(1).catch("general").default("general") }),
  component: AdminAccountDetail,
});

function AdminAccountDetail() {
  const { id } = useParams({ from: "/admin/_layout/crm/accounts_/$id" });
  const { tab } = Route.useSearch();
  return <AccountDetailPage accountId={id} role="admin" activeTab={tab} />;
}
